import styled from "styled-components";
import { Select } from "@mui/material";

export const Container = styled.div<{ width: string }>`
  display: flex;
  flex-direction: column;
  width: ${(props) => props.width};
`;

export const StyledSelect = styled(Select)`
  & .MuiOutlinedInput-notchedOutline {
    border-radius: 8px;
  }
`;

export const Placeholder = styled.p`
  color: #a3a3a6;
  margin: 0;
`;

export const Label = styled.label`
  font-size: 14px;
  font-family: Inter;
  margin-bottom: 8px;
  color: #000000;
`;
